import { Component, OnInit } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Fit, FitError } from 'src/app/core/models/fit.model';
import { DynamoPage, Pagination, PaginationDynamoFiltersDateRequest, PaginationDynamoFiltersRequest, PaginationDynamoRequest, PaginationRequest } from 'src/app/core/models/pagination.model';
import { User } from 'src/app/core/models/user.model';
import { FitService } from 'src/app/core/services/fit.service';
import { LoginService } from 'src/app/core/services/login.service';
import { environment } from 'src/environments/environment';
import * as utils from 'src/app/shared/helpers/utils';
import { Entity } from 'src/app/core/models/entity.model';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from 'src/app/core/services/settings.service';
import { formatDate } from '@angular/common';
import { PaginationService } from 'src/app/core/services/pagination.service';
import { ConfigService } from 'src/app/core/services/config.service';


@Component({
  selector: 'hbo-fit-errors',
  templateUrl: './fit-errors.component.html',
  styleUrls: ['./fit-errors.component.scss']
})
export class FitErrorsComponent implements OnInit {

  madeForYouImageUrl = environment.apiMadeForYouUrl + '/backoffice/tags/img/';

  fitErrors$ = new Observable<Pagination<FitError>>;

  user: User = utils?.localStorageGetItem('user');


  measures: { [key: string | number]: any } = {};
  //measures$ = of(this.measures);

  prevDynamoKey!: string;
  lastDynamoKey!: string;

  entities_filter!: Entity[];
  types_filter!: Array<{ value: string; label: string }>;

  fullLastDynamoKey!: string;

  fitLabelsMapping: any = {
    "shop": "shop_id",
    "fitId": "code_measure",
    "internalReference": "internalRef",
    "fitDateLocal": "date",
    "fitDateUTC": "date",
    "status": "finished"
  }

  columns!: string[];

  constructor(
    private configSvc: ConfigService,
    public translateService: TranslateService,
    private fitService: FitService,
    private loginService: LoginService,
    private settingsService: SettingsService,
    public dynamoPaginationService: PaginationService
  ) {
    this.user.childEntities = this.configSvc.currentConfigValue.childEntities;
  }

  ngOnInit() {
    this.dynamoPaginationService.resetGazeMapPagination();
    this.dynamoPaginationService.resetFitPagination();
    //this.searchFitErrors();
    //this.searchFits();
    this.fitService.currentFitConfigValue.pagination
      ? this.searchFitError(this.fitService.currentFitConfigValue.pagination)
      : null;
    let storageFitFilter = JSON.parse(localStorage.getItem('fitFilter')!) as PaginationDynamoRequest
    storageFitFilter
      ? (
        this.fitService.setCurrentFitParamConfig('pagination', storageFitFilter),
        this.searchFitError(storageFitFilter)
      )
      : this.searchFitError();
  }

  public handleMissingImage(event: Event) {
    (event.target as HTMLImageElement).src = 'assets/images/no_img_avaliable.jpg';
  }

  searchFitError(pagination?: PaginationDynamoRequest) {
    //columns by role
    //columns by role
    this.user.roleId == 4
      ? this.columns = ['shop', 'fitId', 'internalReference', 'fitDateLocal']
      : this.columns = ['crossShopId', 'shop', 'fitId', 'internalReference', 'fitDateLocal', 'fitDateUTC'];
    this.loginService.userStore.subscribe(user => {
      user.childEntities = this.user.childEntities;
      this.entities_filter = user.childEntities!.filter(entity => entity.entityTypeId == 4);
      this.types_filter = [
        {value:'pending', label:'COMMON.PENDING'},
        {value:'finished', label:'COMMON.FINISHED'}
      ];
      let queryStringParams: PaginationDynamoRequest = {};
      let queryStringParamsArray: any[] = [];
      queryStringParams.role = this.user.role?.id == 4 ? 'shop' : 'admin';
      queryStringParams.per_page = pagination?.perPage || 10;
      queryStringParams.entity_id = String(this.user.entity.internalCode) ?? String(this.user.entity.id);
      ///determine usin prev, last and reverse keys
      !pagination?.dynamoReverse
        ? pagination?.dynamoLastKey
          ? queryStringParams.last_key = pagination?.dynamoLastKey
          : null
        : pagination?.dynamoPrevKey && pagination?.page! > 1
          ? queryStringParams.last_key = pagination?.dynamoPrevKey
          : null;
      !pagination?.dynamoReverse
        ? queryStringParams.reverse_search = false
        : pagination?.page! > 1 || pagination?.page! < 0
          ? queryStringParams.reverse_search = pagination?.dynamoReverse
          : null;
      let filters: PaginationDynamoFiltersRequest = {};
      let date: PaginationDynamoFiltersDateRequest = {};
      console.log(pagination);
      //dates
      console.log('set filters');
      console.log(this.fitService.currentFitConfigValue.partners);
      console.log(this.fitService.currentFitConfigValue.shops_selected);
      pagination?.filter_params
        ? pagination.filter_params!['entities'] = this.fitService.currentFitConfigValue.shops_selected
        : null;
      /*let partners: string;
      pagination?.filter_params && pagination?.filter_params!['entities'] && pagination?.filter_params!['entities'].length
        ? partners = pagination.filter_params!['entities'].map((entity: { internalCode: string; id: number; }) => entity.internalCode ?? entity.id).join('+')
        : this.user.role?.id != 4
          ? partners = user.childEntities!.filter(entity => entity.entityTypeId == 4).map(entity => entity.internalCode ?? entity.id).join('+')
          : partners = `${user.entity.name}`;
      !pagination?.filter_params || (pagination?.filter_params && !pagination?.filter_params!['entities'])
        ? delete queryStringParams.shop_id
        : queryStringParams.shop_id = partners;*/

      this.configSvc.currentConfigValue.fitsEntitiesSelected?.length
        ? queryStringParams.shop_id = this.configSvc.currentConfigValue.fitsEntitiesSelected?.filter((entity: Entity) => entity.entityTypeId == 4).map((entity: Entity) => entity.internalCode ?? entity.id).join('+')
        : null;



      queryStringParams.error = 1;
      //force to let development
      //queryStringParams.shop_id = 'CR-SURFACING';
      //queryStringParams.shop_id = 'prueba-2-optica-headoffice+prueba-3-optica-headoffice+OPTICA2A+OPTICA1A+OPTICA2B+Randstad 1+HEAD_OPTICA1A+Randstad 2+OPTICA1B+prueba-optica-headoffice';
      //queryStringParams.shop_id = 'OPTICA1A+OPTICA2B+OPTICA1B';//OPTICA2B OPTICA1B
      //queryStringParams.shop_id = '21';
      //queryStringParams.shop_id = 'OPTICA1A';

     
      if (pagination?.filter_params!) {
        console.log(pagination?.filter_params);
        filters.date = {};
        pagination?.filter_params!['startDate'] != ''
          ? filters.date.init = pagination?.filter_params!['startDate']
          : null;
        pagination?.filter_params!['endDate'] != ''
          ? filters.date.end = pagination?.filter_params!['endDate']
          : null;
        pagination?.filter_params!['type'] && pagination?.filter_params!['type'] != ''
          ? filters['finished'] = pagination?.filter_params!['type'] == 'finished' ? true : false
          : null;
        pagination?.filter_params!['deleted']
          ? filters['hidden'] = pagination?.filter_params!['deleted'] ? 'True' : 'False'
          : null;
      } else {
        filters.date = { end: formatDate(new Date(), 'yyyy-MM-dd', 'en') };
        /*if (this.user.role?.id == 1) {
          filters.date.init = formatDate(new Date(new Date().getTime() - (60 * 60 * 24 * 7 * 1000)), 'yyyy-MM-dd', 'en')
        }*/
      }
      !filters.date.end && !filters.date.init
        ? delete filters.date
        : null;
      //delete filters.date;
      /*filters.date = date;
      filters.date!.end = "";
      filters.date!.init = "";*/
      pagination?.search_params ? queryStringParams.search_params = pagination?.search_params : null;
      pagination?.sort
        ? queryStringParams.sort = this.fitLabelsMapping[pagination?.sort]
        : null;
      pagination?.order
        ? queryStringParams.order = pagination?.order
        : null;
      //filters['shop_id'] = partners;
      //convert to base64 filter
      queryStringParams.filter_params = filters;
      Object.entries(queryStringParams).map(elem => {
        elem[0] == 'filter_params'
          ? queryStringParamsArray.push(`${elem[0]}=${btoa(JSON.stringify(elem[1]))}`)
          : queryStringParamsArray.push(`${elem[0]}=${elem[1]}`)
      });
      let testBase64 = btoa(JSON.stringify(filters));
      console.log(queryStringParams);
      this.fitErrors$ = this.fitService.index2(queryStringParamsArray.join('&')).pipe(map(fits => ({
        total: fits.tag_list.length,
        perPage: pagination?.perPage || 10,
        currentPage: pagination?.page || 1,
        lastPage: 1,
        from: 1,
        to: fits.tag_list.length,
        data: pagination?.dynamoReverse ? fits.tag_list.reverse() : fits.tag_list,
        dynamoLastKey: this.setPrevKey(pagination?.page, pagination?.sort || queryStringParams.sort, fits.tag_list[0], fits.last_key, pagination!),
        dynamoPrevKey: pagination?.dynamoPrevKey || null,
        dynamoFullLastKey: fits.full_last_key || null,
        dynamoReverse: pagination?.dynamoReverse || false,
        sort: pagination?.sort || queryStringParams.sort,
        order: pagination?.order || queryStringParams.order,
        search_params: pagination?.search_params || queryStringParams.search_params,
        filter_params: pagination?.filter_params || queryStringParams.filter_params,
        showFilters: pagination?.showFilters || false,
        role: pagination?.role || queryStringParams.role,
        roleId: pagination?.roleId || this.user.role?.id,
        selectorEntitiesSearch: pagination?.selectorEntitiesSearch || ''
      })));
    });
  }

  setPrevKey(_page: number = 1, _sort: string | undefined, _previous: Fit, _key: string, _pagination: PaginationRequest) {
    console.log(_key);
    _pagination && _previous
      ? (
        this.prevDynamoKey = this.base64Previous(_sort, _previous),//clone
        this.lastDynamoKey = _key
      )
      : this.lastDynamoKey = _key
    let dynamoPage: DynamoPage = {
      page: _page,
      lastKey: _key,
      prevKey: this.prevDynamoKey,
      visible: true,
      hide: false
    }
    this.dynamoPaginationService.setCurrentFitDynamoPage(dynamoPage);
    return _key
  }
  base64Previous(_sort: string | undefined, _previous: Fit) {
    let previous: any = { 'TagID': '', 'date': '' };
    previous.TagID = _previous.TagID;
    previous.date = _previous.date;
    _sort
      ? previous[_sort] = _previous[_sort]
      : null
    console.log(previous);
    console.log(btoa(JSON.stringify(previous)));
    return btoa(JSON.stringify(previous))
  }

  persistanceFilters(_testId?: string) {
    console.log('hola');
    this.fitService.currentFitConfigValue.pagination
      ? localStorage.setItem('FitFilter', JSON.stringify(this.fitService.currentFitConfigValue.pagination))
      : null;
    //this._location.go('/gaze-maps/' + _testId)
  }


  searchFitErrors(pagination?: PaginationRequest) {
    this.loginService.userStore.subscribe(user => {
      const partners = user.childEntities!.map(entity => entity.internalCode ?? entity.id).join('+');

      this.fitErrors$ = this.fitService.errors(partners).pipe(map(fitErrors => ({
        total: fitErrors.tag_list.length,
        perPage: 10,
        currentPage: 1,
        lastPage: 1,
        from: 1,
        to: fitErrors.tag_list.length,
        data: fitErrors.tag_list
      })));
    });
  }

  updateFitReference(fitError: FitError) {
    this.fitService.updateReference(fitError.TagID, fitError.internalRef).subscribe();
  }

  updateFitComments(fitError: FitError) {
    this.fitService.updateComments(fitError.TagID, fitError.comments).subscribe();
  }

  getTar(fitError: FitError) {
    this.fitService.tar(fitError.TagID).subscribe(tar => window.open(tar.location, '_blank'));
  }

  setCrossShop = (_shopId: string) => {
    return this.user.childEntities!.find((entity: Entity) => String(entity.internalCode) === _shopId)?.name
  }

}
